import fetch from '@adc/fetch';
import configment from '@adc/configment';
const initiateIdentityVerification = (req) => fetch(`${configment.get('RESI_MS_PROFILE')}/resi/profile/v1/id-verification/`, {
    method: 'POST',
    headers: {
        Accept: '*/*',
    },
    req,
});
const performProcessIdUploadVerification = () => fetch
    .fromService('RESI_MS_PROFILE')
    .post(`/resi/profile/v1/id-verification/process-id-uploaded`)
    .then(res => res.body);
export { initiateIdentityVerification, performProcessIdUploadVerification };
//# sourceMappingURL=providers.js.map